import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { useHistory } from 'react-router-dom';

function compareDimensions(wardrobesConfigs, copyWardrobe, activeWardrobe) {
  if (copyWardrobe.length) {
    return (
      wardrobesConfigs[activeWardrobe].dimensions.x !== copyWardrobe[activeWardrobe].dimensions.x ||
      wardrobesConfigs[activeWardrobe].dimensions.z !== copyWardrobe[activeWardrobe].dimensions.z
    );
  }
  return false;
}

const ProgressBarItem = props => {
  const { name, active, link, ownProgressive, func, wardrobesConfigs, activeWardrobe } = props;

  const history = useHistory();
  const path = history.location.pathname.includes('wardrobe-body-configuration');
  const copyWardrobe = reactLocalStorage.getObject('copyWardrobe');
  const checkDimensions = compareDimensions(wardrobesConfigs, copyWardrobe, activeWardrobe);

  const blockProgresiveBar = () => {
    if (path) {
      if (!checkDimensions) {
        if (copyWardrobe.length) {
          return 'pointer-all';
        } else {
          return '';
        }
      }
    } else {
      if (copyWardrobe.length) {
        return 'pointer-all';
      } else {
        return '';
      }
    }
  };

  return (
    <Link
      to={link}
      onClick={func}
      className={`progress-bar__item ${active ? 'active' : ''} ${
        ownProgressive ? 'display-after pointer-all' : ''
      } ${blockProgresiveBar()} `}>
      {name}
    </Link>
  );
};

ProgressBarItem.propTypes = {
  name: PropTypes.string,
  active: PropTypes.bool.isRequired,
  link: PropTypes.string,
  ownProgressive: PropTypes.bool,
  func: PropTypes.func,
};

export default ProgressBarItem;
